module.exports = __webpack_public_path__ + "static/scale-model-of-colonial-industrial-quarter-in-allentown-pennsylvania-c40e9dbf70adbd8f9b3b640b1cd8adab.png";